import {default as _Select, Props} from "react-select";

export const Select = ({className, ...rest}: Props) => {
    const classes = 'react-select react-select-container ' + (className || '');

    return <_Select
        className={classes}
        noOptionsMessage={() => 'Nada encontrado'}
        classNamePrefix="react-select"
        {...rest}
    />
}
